import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Legend, Filler);

const FPS = 30
const PLAYBACK_SECONDS = 10

function DashboardActiveMainPedalsInputs({value}) {
    const MAX_POINTS = PLAYBACK_SECONDS * FPS;
    var gas = Math.round(value.gas * 100) / 100;
    var brake = Math.round(value.brake * 100) / 100;
    var clutch = 1 - Math.round(value.clutch * 100) / 100;

    const [dataBuffer, setDataBuffer] = useState({
        gas: new Array(MAX_POINTS).fill(0),
        brake: new Array(MAX_POINTS).fill(0),
        clutch: new Array(MAX_POINTS).fill(0)
    });

    useEffect(() => {
        const interval = setInterval(() => {
        setDataBuffer(prev => ({
            gas: [...prev.gas, gas].slice(-MAX_POINTS),
            brake: [...prev.brake, brake].slice(-MAX_POINTS),
            clutch: [...prev.clutch, clutch].slice(-MAX_POINTS)
        }));
        }, 1000/FPS);

        return () => clearInterval(interval);
    }, [gas, brake, clutch, MAX_POINTS]);

    const data = {
        labels: Array.from({ length: MAX_POINTS }, (_, i) => `${((i - MAX_POINTS) * 0.2).toFixed(1)}s`),
        datasets: [
            {
                data: dataBuffer.gas,
                borderColor: '#22c55e',
                backgroundColor: 'rgba(34, 197, 94, 0.1)',
                fill: true,
                pointRadius: 0,
                tension: 0.4,
                borderWidth: 1.5,
            }, {
                data: dataBuffer.brake,
                borderColor: '#ef4444',
                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                fill: true,
                pointRadius: 0,
                tension: 0.4,
                borderWidth: 1.5,
            }, {
                data: dataBuffer.clutch,
                borderColor: '#808080ff',
                backgroundColor: 'rgba(80, 80, 80, 0.1)',
                fill: true,
                pointRadius: 0,
                tension: 0.4,
                borderWidth: 1.5,
            }
        ]
    };

    const options = {
        animation: false,
        maintainAspectRatio: false,
        clip: false,
        scales: {
        y: {
            min: 0,
            max: 1,
            ticks: { display: false },
            grid: { color: 'rgba(255,255,255,0.05)' },
            offset: false,
            beginAtZero: true
        },
        x: {
            display: false,
            grid: { display: false },
            ticks: { display: false },
            offset: false,
            boundaryGap: false,
        }
        },
        plugins: {
            legend: { display: false}
        },
        layout: {
            padding: 0
        },
    };

    return (
        <div className="rounded-lg bg-[#233648]/30 p-3 border border-[#324d67]/50 flex flex-col gap-3">
            <span className="text-[10px] uppercase font-bold text-[#92adc9]">Pedal Inputs</span>
            <div className="flex justify-center gap-5 h-32">
                <div className="flex-1 flex max-w-12 flex-col items-center gap-1">
                    <div className="relative w-full flex-1 bg-[#111a22] rounded overflow-hidden bg-background-dark/50">
                        <div className="absolute bottom-0 left-0 w-full bg-acc-green shadow-[0_0_10px_rgba(11,218,91,0.5)] transition-[height] duration-20 linear" style={{height: Math.floor(value.gas*100)+ "%"}}></div>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <span className="text-xs font-black drop-shadow-md">{Math.floor(value.gas*100)}%</span>
                        </div>
                    </div>
                    <span className="text-[9px] uppercase font-bold text-acc-green">Throttle</span>
                </div>

                <div className="flex-1 flex max-w-12 flex-col items-center gap-1">
                    <div className="relative w-full flex-1 bg-[#111a22] rounded overflow-hidden bg-background-dark/50">
                        <div className="absolute bottom-0 left-0 w-full bg-acc-red shadow-[0_0_10px_rgba(250,98,56,0.5)] transition-[height] duration-20 linear" style={{height: Math.floor(value.brake*100) + "%"}}></div>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <span className="text-xs font-black drop-shadow-md">{Math.floor(value.brake*100)}%</span>
                        </div>
                    </div>
                    <span className="text-[9px] uppercase font-bold text-acc-red">Brake</span>
                </div>

                <div className="flex-1 flex max-w-12 flex-col items-center gap-1">
                    <div className="relative w-full flex-1 bg-[#111a22] rounded overflow-hidden bg-background-dark/50">
                        <div className="absolute bottom-0 left-0 w-full bg-[#7a7a7aff] shadow-[0_0_10px_#7a7a7a85] transition-[height] duration-20 linear" style={{height: Math.floor((1-value.clutch)*100)+ "%"}}></div>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <span className="text-xs font-black drop-shadow-md">{Math.floor((1-value.clutch)*100)}%</span>
                        </div>
                    </div>
                    <span className="text-[9px] uppercase font-bold text-[#92adc9]">Clutch</span>
                </div>
            </div>
            <div className="w-full mt-2 rounded-xl p-2 relative overflow-hidden bg-background-dark/50 content-center" style={{"height": "100px"}}>
                <Line data={data} options={options} />
            </div>
        </div>
    );
}

export default DashboardActiveMainPedalsInputs;